import React, { useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import gsap from 'gsap';

import styles from './ButtonClose.module.scss';

export const ButtonClose = ({
  onClick,
  className,
  ariaLabel,
  motionDisabled,
}) => {
  const lines = [useRef(null), useRef(null)];
  const tweens = useRef({
    lines: null,
  });

  const handleMouseEnter = () => {
    if (!motionDisabled) tweens.current.lines.play();
  };

  const handleMouseLeave = () => {
    if (!motionDisabled) tweens.current.lines.reverse();
  };

  useLayoutEffect(() => {
    tweens.current.lines = gsap.timeline({ paused: true });

    tweens.current.lines.to(
      lines[0].current,
      {
        transformOrigin: 'right',
        scaleX: 0,
        duration: 0.35,
        ease: 'power3.in',
      },
      0.0
    );

    tweens.current.lines.to(
      lines[1].current,
      {
        transformOrigin: 'top',
        scaleY: 0,
        duration: 0.35,
        ease: 'power3.in',
      },
      0.1
    );

    tweens.current.lines.to(
      lines[0].current,
      {
        transformOrigin: 'left',
        scaleX: 1,
        duration: 0.35,
        ease: 'power3.out',
      },
      0.35
    );

    tweens.current.lines.to(
      lines[1].current,
      {
        transformOrigin: 'bottom',
        scaleY: 1,
        duration: 0.35,
        ease: 'power3.out',
      },
      0.45
    );

    return () => {
      if (tweens.current.lines) {
        tweens.current.lines.kill();
        tweens.current.lines = null;
      }
    };
  }, []);

  return (
    <button
      type="button"
      className={classNames(styles.button, className)}
      aria-label={ariaLabel}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span className={styles.icon}>
        <span className={styles.line} ref={lines[0]} />
        <span className={styles.line} ref={lines[1]} />
      </span>
    </button>
  );
};

ButtonClose.defaultProps = {
  className: '',
  ariaLabel: 'Close',
  motionDisabled: false,
};

ButtonClose.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  motionDisabled: PropTypes.bool,
};
